/* eslint-disable */
const keyMap = {
    pc: {
      "undo": "CTRL+Z",
      "redo": "CTRL+Y",
      "tab": "TAB",
      "untab": "SHIFT+TAB",
      "bold": "Bold (CTRL+B)",
      "italic": "Italic (CTRL+I)",
      "underline": "Underline (CTRL+U)",
      "strikethrough": "CTRL+SHIFT+S",
      "removeFormat": "CTRL+BACKSLASH",
      "justifyLeft": "CTRL+SHIFT+L",
      "justifyCenter": "CTRL+SHIFT+E",
      "justifyRight": "CTRL+SHIFT+R",
      "justifyFull": "CTRL+SHIFT+J",
      'ul': 'Unordered list (CTRL+SHIFT+NUM7)',
      'ol': 'Ordered list (CTRL+SHIFT+NUM8)',
      "outdent": "CTRL+LEFTBRACKET",
      "indent": "CTRL+RIGHTBRACKET",
      "formatPara": "CTRL+NUM0",
      "formatH1": "CTRL+NUM1",
      "formatH2": "CTRL+NUM2",
      "formatH3": "CTRL+NUM3",
      "formatH4": "CTRL+NUM4",
      "formatH5": "CTRL+NUM5",
      "formatH6": "CTRL+NUM6",
      "blockquote": "Quote",
      "hr": "Horizontal Rule",
      "insertHorizontalRule": "CTRL+ENTER",
      "linkDialog.show": "CTRL+K"
    },
    mac: {
      "undo": "CMD+Z",
      "redo": "CMD+SHIFT+Z",
      "tab": "TAB",
      "untab": "SHIFT+TAB",
      "bold": "Bold (CMD+B)",
      "italic": "Italic (CMD+I)",
      "underline": "Underline (CMD+U)",
      "strikethrough": "CMD+SHIFT+S",
      "removeFormat": "CMD+BACKSLASH",
      "justifyLeft": "CMD+SHIFT+L",
      "justifyCenter": "CMD+SHIFT+E",
      "justifyRight": "CMD+SHIFT+R",
      "justifyFull": "CMD+SHIFT+J",
      'ul': 'Ordered list (CMD+SHIFT+NUM8)',
      'ol': 'Unordered list (CMD+SHIFT+NUM7)',
      "outdent": "CMD+LEFTBRACKET",
      "indent": "CMD+RIGHTBRACKET",
      "formatPara": "CMD+NUM0",
      "formatH1": "CMD+NUM1",
      "formatH2": "CMD+NUM2",
      "formatH3": "CMD+NUM3",
      "formatH4": "CMD+NUM4",
      "formatH5": "CMD+NUM5",
      "formatH6": "CMD+NUM6",
      "blockquote": "Quote",
      "hr": "Horizontal Rule",
      "insertHorizontalRule": "CMD+ENTER",
      "linkDialog.show": "CMD+K"
    }
}

export const getTooltip = (code) => {
  const isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;
  const keyName = isMac ? 'mac' : 'pc';

  if (keyMap[keyName] && keyMap[keyName][code]) {
    return keyMap[keyName][code].replace('CMD', '⌘').replace('SHIFT', '⇧');
  }
  return null;
}
